import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth, homeFor } from "../lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        navigate(homeFor(res.data), { replace: true, state: { user: res.data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-10 h-10 border-4 border-brand-deep/20 border-t-brand-deep rounded-full animate-spin" />
    </div>
  );
}
